export default __webpack_public_path__ + "1dc5144b679804e4274e118e2bdcd6cf.png";